import { render, staticRenderFns } from "./ButtonsQuestion.vue?vue&type=template&id=c231bc94&"
import script from "./ButtonsQuestion.vue?vue&type=script&lang=js&"
export * from "./ButtonsQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports